import { PagedResult } from '@extrahorizon/javascript-sdk';
import { useQuery } from '@tanstack/react-query';
import { PrescriptionPackage } from 'models/prescription';
import { queryKeys, RAW_ENDPOINTS, sdk } from 'utils/query';

const getPackages = async () => {
  const { data: packages } = await sdk.raw.get<PagedResult<PrescriptionPackage>>(
    `${RAW_ENDPOINTS.PRESCRIPTIONS}/packages?visible=true&sort(duration)`,
  );
  return packages?.data;
};

export const usePackages = () => useQuery({ queryKey: [queryKeys.packages], queryFn: getPackages });
